import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import { isOktaConfigured } from "../config/appConfig";
import { isLogoutInitiated } from "./logoutState";

const SecureRoute = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const logoutInitiated = isLogoutInitiated();

  useEffect(() => {
    if (
      !isOktaConfigured ||
      !oktaAuth ||
      logoutInitiated ||
      !authState ||
      authState.isAuthenticated ||
      authState.isPending
    ) {
      return;
    }

    oktaAuth.signInWithRedirect();
  }, [authState, oktaAuth, logoutInitiated]);

  if (!isOktaConfigured) {
    return children;
  }

  if (logoutInitiated) {
    return null;
  }

  if (!authState || authState.isPending || !authState.isAuthenticated) {
    return null;
  }

  return children;
};

SecureRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SecureRoute;
